import type { WorkTask } from '@/features/work-management/workTasks.api';

import type { ProjectColumnKey } from './column-types';

/** Columns this module renders. Anything else is the table's own cell. */
export const SHARED_CELL_COLUMNS = [
  'priority',
  'description',
  'tags',
  'taskType',
  'estimateHours',
  'actualHours',
  'storyPoints',
  'dateCreated',
  'dateUpdated',
  'dateDone',
  'dependencies',
  'parentTask',
] as const satisfies readonly ProjectColumnKey[];

export type SharedCellColumn = (typeof SHARED_CELL_COLUMNS)[number];

export function isSharedCellColumn(k: ProjectColumnKey): k is SharedCellColumn {
  return (SHARED_CELL_COLUMNS as readonly string[]).includes(k);
}

/**
 * Parent title: the server's answer first, then the loaded list; never the id.
 * A parent that cannot be resolved (deleted, or outside this page) reads as
 * "Unavailable parent" — a truthful statement that it exists but cannot be named.
 */
export function parentTitleFor(
  task: WorkTask,
  loaded?: ReadonlyArray<Pick<WorkTask, 'id' | 'title'>>,
): string | null {
  if (!task.parentTaskId) return null;
  if (task.parentTitle) return task.parentTitle;
  const hit = loaded?.find((t) => t.id === task.parentTaskId);
  return hit?.title ?? 'Unavailable parent';
}

